<template>
    <v-container fluid>
      <v-card>
        <v-toolbar color="secondary" flat>
          <v-toolbar-title>Send Bulk Sms</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" small text to="/subscriber/sms">
            <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <!-- editor -->
          sms logic comes here
            <!-- <editor :initial="dataItem" @data="save"></editor> -->
          <!-- end -->
        </v-card-text>
      </v-card>
    </v-container>
</template>

<script>
export default {
  components: {

  },
  data: () => ({
    dataItem: {}
  }),
  methods: {
    save() {
      // logic
    }
  }
};
</script>